'use strict';

var d3 = require('d3');

/**
 * Gaps
 *
 * Renders bars with no data
 *
 * @param svgPatternService
 * @returns {Function}
 * @constructor
 */
var Gaps = function Gaps(svgPatternService) {
  return function () {
    var params, scales;

    /**
     *
     * @param container
     */
    var gaps = function gaps(container) {
      var barWidth = params.direction === 'vertical' ? scales.yScale.rangeBand() : scales.xScale.rangeBand();
      var isViewport = container.filter('.viewport-groups').size() === 1;
      var gaps = container.selectAll('.stack.gap.visible');
      var patternId = isViewport ? 'gap-pattern-viewport' : 'gap-pattern';
      var patternUrl = svgPatternService.getPatternUrl(patternId);
      gaps.each(function (d) {
        // remove all gap children
        d3.select(this).selectAll('*').remove();
        var gaps = d3.select(this).selectAll('.gap').data([d]);
        gaps.enter().append('rect').attr('class', function (d) {
          return d.cssClass ? 'gap ' + d.cssClass : 'gap';
        });
        gaps.attr({
          'width': barWidth,
          'height': params.height
        }).style('fill', function (d) {
          if (d.patternId === 'gap-solid') {
            return false;
          }
          if (!isViewport && svgPatternService.isPatternAvailable(d.patternId)) {
            return svgPatternService.getPatternUrl(d.patternId);
          }
          return patternUrl;
        });
        if (params.isSparse) {
          gaps.attr({
            'x': params.xBarPadding,
            'width': function width(d) {
              return Math.abs(params.xScaleFactor * (d.gapLength * params.xGapSize) - params.xBarPadding * 2);
            }
          });
        }
      });
    };

    /**
     * Sets/gets circle's params
     * @param value
     * @returns {group}
     */
    gaps.params = function (value) {
      params = value;
      return gaps;
    };

    /**
     * Sets/gets circle's scales
     * @param value
     * @returns {group}
     */
    gaps.scales = function (value) {
      scales = value;
      return gaps;
    };
    return gaps;
  };
};
Gaps.$inject = ['SvgPatternService'];
module.exports = Gaps;